import { hasDemand } from "lib/authorization/has-demand"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { MaintenanceLibraryExplorer } from "routes/component-library/explorer/maintenance-library-explorer"
import { authoringRoute } from "../authoring.runtime"

authoringRoute.register(
    "component-library",
    <DemandGuard demands={["user"]}>
        <MaintenanceLibraryExplorer $lazy />
    </DemandGuard>
)

registerConditionalPageNavigation(
    () => hasDemand("user"),
    "/authoring/component-library",
    "Component Library",
    "mdi:bookshelf",
    {
        group: "Work Packages",
        priority: 591,
        subPaths: true,
    }
)
